import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=7b2b610d&scoped=true&lang=true&"
import script from "./CertificateList.vue?vue&type=script&lang=js&"
export * from "./CertificateList.vue?vue&type=script&lang=js&"
import style0 from "./CertificateList.vue?vue&type=style&index=0&id=7b2b610d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b610d",
  null
  
)

export default component.exports